import { observer } from 'mobx-react';
import { computed, action } from 'mobx';
import { bind, inject } from '../../../utils/decorators';
import * as React from 'react';
import { InputGroup, FormControl, Table, Panel, FormGroup } from 'react-bootstrap';
import { DmgKalibrierungStore } from '../../../stores/DmgKalibrierungStore';
import * as ApiTypes from '../../../models/ApiTypesDmg';

@observer
class DmgPruefortParameterKomponente extends React.Component<{ ziel: ApiTypes.IDmgKalibrierungPruefortParameterKomponente; beschriftung: string; einheit: string; }, {}> {

  @inject(DmgKalibrierungStore) store: DmgKalibrierungStore;

  @bind @action handleIstWertChange(ev: React.FormEvent<FormControl>) {
    this.props.ziel.wert = (ev.target as HTMLInputElement).value !== '' ? (ev.target as HTMLInputElement).valueAsNumber : null;
  }

  @computed get imToleranzbereich() {
    const { wert, min, max } = this.props.ziel;
    if ((wert !== null) && ((wert < min) || (wert > max))) {
      return false;
    }
    return true;
  }

  public render() {
    const { wert, min, max } = this.props.ziel;
    return (
      <tr>
        <td className="beschriftung">{this.props.beschriftung}</td>
        <td className="min">{min}</td>
        <td className="messwert">
          <FormGroup validationState={wert === null ? 'error' : undefined}>
            <InputGroup>
              <FormControl
                type="number"
                step="any"
                readOnly={this.store.readOnly}
                onChange={this.handleIstWertChange}
                value={wert !== null ? wert : ''}
                className={wert !== null && this.imToleranzbereich === true ? 'text-success' : 'text-danger'}
              />
              <InputGroup.Addon>{this.props.einheit}</InputGroup.Addon>
            </InputGroup>
          </FormGroup>
        </td>
        <td className="max">{max}</td>
      </tr>
    );
  }
}

class DmgPruefortTemperaturHinweis extends React.Component<{}, {}> {
  public render() {
    return (
        <tr>
          <td colSpan={4}>
            <div className="value-error" style={{textAlign: 'left'}}>Der Temperaturunterschied zum Beginn muss unter ±1°C liegen</div>
          </td>
        </tr>
    );
  }
}

interface IDmgPruefortParameterProps {
  titel: string;
  ziel: ApiTypes.IDmgKalibrierungPruefortParameter;
  referenz?: ApiTypes.IDmgKalibrierungPruefortParameter;
}

/** Exportierte Komponente für Eingabe und Validierung der Prüfortparameter Kalibrierung Druckmessgerät */
@observer
export default class DmgPruefortParameter extends React.Component<IDmgPruefortParameterProps, {}> {

  @computed get temperaturHinweis() {
    if (!this.props.referenz || this.props.ziel.lufttemperatur.wert == null) {
      return false;
    }
    if (this.props.referenz.lufttemperatur.wert !== null) {
      return (Math.abs(this.props.referenz.lufttemperatur.wert - this.props.ziel.lufttemperatur.wert) > 1.0);
    }
    return false;
  }

  public render() {
    return(
      <Panel header={this.props.titel} collapsible={true} defaultExpanded={true}>
        <Table striped={false} bordered={false} condensed={true} hover={false} className="bps-pruefortparameter">
          <thead>
            <tr>
                <th/>
                <th>Min.</th>
                <th>Messwert</th>
                <th>Max.</th>
            </tr>
          </thead>
          <tbody>
            <DmgPruefortParameterKomponente ziel={this.props.ziel.lufttemperatur} beschriftung="Lufttemperatur" einheit="°C"/>
            {this.temperaturHinweis && <DmgPruefortTemperaturHinweis/>}
            <DmgPruefortParameterKomponente ziel={this.props.ziel.luftfeuchtigkeit} beschriftung="Luftfeuchtigkeit" einheit="%"/>
          </tbody>
        </Table>
      </Panel>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/dmg/DmgPruefortParameter.tsx